import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useEffect, useState } from "react";

interface CounterProps {
  defaultValue?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  label?: string;
  minW?: string;
  color?: string;
  fontSize?: string;
}

const Counter: React.FC<CounterProps> = (props: CounterProps) => {
  const {
    defaultValue = 0,
    max = Infinity,
    min = -Infinity,
    onChange,
    label = "",
    minW,
    color = "text-green-400",
    fontSize = "text-[22px]",
  } = props;

  const [count, setCount] = useState<number>(defaultValue);

  // ✅ Đồng bộ lại khi parent đổi giá trị
  useEffect(() => {
    setCount(defaultValue);
  }, [defaultValue]);

  const decrement = () => {
    const newValue = Math.max(min, count - 1);
    setCount(newValue);
    onChange?.(newValue);
  };

  const increment = () => {
    const newValue = Math.min(max, count + 1);
    setCount(newValue);
    onChange?.(newValue);
  };

  return (
    <div className="flex items-center justify-center p-1.5 border-2 rounded-full h-12 border-gray-400 w-fit">
      <button
        className={`rounded-3xl flex items-center justify-center ${color}`}
        onClick={decrement}
        disabled={count <= min}
      >
        <LeftOutlined className="text-2xl" />
      </button>

      <div className={`flex flex-col items-center px-3 mb-0.5 ${minW} ${fontSize}`}>
        <div className="font-medium text-white flex gap-1">
          <p className="whitespace-nowrap">
            {label} {count}
          </p>
        </div>
      </div>

      <button
        className={`rounded-3xl flex items-center justify-center ${color}`}
        onClick={increment}
        disabled={count >= max}
      >
        <RightOutlined className="text-2xl" />
      </button>
    </div>
  );
};


export default Counter;
